// COMPONENTS
// TYPES
// STYLES
import type { TRole } from '@timeedit/types/lib/types';
import { Form, Input } from '@timeedit/ui-components/antd';
import RolePermissionTable from '../../../components/RolePermissionTable';
import SectionHeader from '../../../components/SectionHeader';
// i18N
import intl from '../../../i18n/intl';

type Props = {
  onChange: (prop: string, value: any) => void;
  onAddRolePermission: (rolePermissionIds: number) => void;
  onDeleteRolePermission: (rolePermissionIds: number) => void;
  role: TRole;
};

const language: any = intl.messages;

const RolePermissionDetailPage = ({
  onChange,
  role,
  onAddRolePermission,
  onDeleteRolePermission,
}: Props) => {
  const [form] = Form.useForm();

  return (
    <>
      <SectionHeader
        listChoiceHeading={role.name || undefined}
        displayProp={false}
        history={false}
      />
      <Form layout="vertical" form={form}>
        <Form.Item label={`${language.name}:`}>
          <Input
            size="small"
            value={role.name}
            onChange={(e) => onChange('name', e.target.value)}
          />
        </Form.Item>
        <p className="small-heading-text">
          {language.id}: {role.id}
        </p>
        <Form.Item label={`${language.description}:`}>
          <Input.TextArea
            size="small"
            rows={3}
            value={role.description || undefined}
            onChange={(e) => onChange('description', e.target.value)}
          />
        </Form.Item>
        <p className="small-heading-text">Role permissions:</p>
        <RolePermissionTable
          rolePermissionIds={role.rolePermissions}
          onAdd={onAddRolePermission}
          onRemove={onDeleteRolePermission}
        />
      </Form>
    </>
  );
};

export default RolePermissionDetailPage;
